import { render, staticRenderFns } from "./ElementFormTextarea.vue?vue&type=template&id=1b8db985&"
import script from "./ElementFormTextarea.vue?vue&type=script&lang=js&"
export * from "./ElementFormTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ElementFormTextarea.vue?vue&type=style&index=0&id=1b8db985&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports